import { isArray, isObject, isDate, isRegExp } from 'lodash'

/**
 * Drop all instances of a key in an object, no matter how deeply nested it is.
 * This is good for an instance if you had something like an index value many times in an object and you want to remove it.
 * Giving the 'index' key will drop any place it occurs in the object.
 * This also works on arrays of objects.
 *
 * @param obj | Object | Object[]
 * @param keysToOmit | String[]
 * @returns
 */
export const dropAllKeyInstances = (obj: Object, keysToOmit: string[]) => {
  // If it's an array, recursively process each element
  // Since in Javascript both a JSON-like object and Array both have a typeof object.
  if (isArray(obj)) {
    return obj.map((item) => dropAllKeyInstances(item, keysToOmit))
  }

  // lodash isObject() rreturns true on arrays, but we've already cleared it of being an array first.
  // So we'll check that it's an object but not a date or regular expression object.
  // Keys not to be omitted will be cast to the reducer 'result' while keys needing dropped get pruned...
  // ...Because 'result' is an accumulator. Since 'result[key]' isn't set when includes() is true you lose the key.
  if (isObject(obj) && !isDate(obj) && !isRegExp(obj)) {
    return Object.keys(obj).reduce((result, key) => {
      if (!keysToOmit.includes(key)) {
        result[key] = dropAllKeyInstances(obj[key], keysToOmit)
      }
      return result
    }, {})
  }

  // For primitives, dates, regex, etc., return as is
  return obj
}
